import { Appointment } from './appointment.model';
import { AppointmentsHelper } from '../helpers/appointments-helper';
import { AppointmentOutcomeTypes } from '../../enums/appointment-outcome-types';
import { BuyerSummary } from './buyer-summary.model';
import { DayTypes } from '../../enums/day-types';
import { Site } from './site.model';
import moment from 'moment';

export class DayDetails {
  dayId: number;
  dayNumber: string;
  dayWeekName: string;
  siteName: string;
  abbreviatedSiteName: string;
  isDayOff: boolean;
  dayType: DayTypes;
  dailyAppointments: Array<Appointment> = [];
  appointmentLength: number;
  dayOffText = 'DAY OFF';
  fixedAppointmentStyle = 'appointment-lunch';
  scheduleUnavailableText = 'Schedule Unavailable';

  calendarHeight: number;
  numberOfHours: number;
  calendarPixelPerMinuteCount: number;
  browserFontSize: number;

  constructor(dayId: number, dayNumber: string, dayWeekName: string, site: Site, dayType: DayTypes, buyer: BuyerSummary, appointments: Array<Appointment>,
      calendarHeight: number, numberOfHours: number, dayDate: number) {
    
    this.dayId = dayId;
    this.dayNumber = dayNumber;
    this.dayWeekName = dayWeekName;
    this.dayType = dayType;
    this.appointmentLength = buyer.durationInMinutes;

    this.calendarHeight = calendarHeight;
    this.numberOfHours = numberOfHours;
    this.calendarPixelPerMinuteCount = calendarHeight / (numberOfHours * 60);
    this.browserFontSize = Number(window.getComputedStyle(document.body, null).getPropertyValue('font-size').replace('px', ''));

    if (site) {
      this.siteName = site.name;
      this.abbreviatedSiteName = site.abbreviatedSiteName;
      const siteDay = site.siteDays.find(x => x.dayId === dayId);
      this.isDayOff = false;
      if (appointments) {
        this.dailyAppointments = appointments.filter(app => app.status !== AppointmentOutcomeTypes.PurchaseCancelled);
        this.dailyAppointments.forEach(dailyApp => {
          dailyApp.status = dailyApp.status === '' ? AppointmentOutcomeTypes.PreAppointmentConfirmed : dailyApp.status;
          dailyApp.statusStyle = AppointmentsHelper.setStatusStyle(dailyApp.status, dailyApp.isWalkIn);
          dailyApp.timeStyle = AppointmentsHelper.setTimeStyle(dailyApp.status, dailyApp.isWalkIn);
          dailyApp.appointmentTopPosition = AppointmentsHelper.setAppointmentStartPosition(moment(dailyApp.startTime, 'HH:mm:ss'), calendarHeight, numberOfHours) / this.browserFontSize;
          dailyApp.appointmentHeight = AppointmentsHelper.setAppointmentHeight(this.appointmentLength, this.calendarPixelPerMinuteCount) / this.browserFontSize;
        });

        // Create fixed appointments for maintenance, lunch and break
        if (siteDay?.lunchDurationInMinutes > 0)
        {
          this.createFixedAppointment('LUNCH', siteDay?.lunchStartTime, siteDay?.lunchDurationInMinutes);
        }
        if (siteDay?.maintenanceDurationInMinutes > 0)
        {
          this.createFixedAppointment('MAINTENANCE', siteDay?.maintenanceStartTime, siteDay?.maintenanceDurationInMinutes);
        }
        if (siteDay?.breakDurationInMinutes > 0)
        {
          this.createFixedAppointment('BREAK', siteDay?.breakStartTime, siteDay?.breakDurationInMinutes); // Mandatory break for ALL buyers
        }

        AppointmentsHelper.findOverlappingAppointments(this.dailyAppointments);
        this.dailyAppointments.forEach(dailyApp => {
          dailyApp.appointmentWidth = AppointmentsHelper.setAppointmentWidth(dailyApp.appOverlaps);
          dailyApp.appointmentLeft = AppointmentsHelper.setAppointmentLeft(dailyApp.appSequence, dailyApp.appOverlaps);
        });
      }
    } else {
      const sevenDayDateWindow = new Date();
      sevenDayDateWindow.setDate(sevenDayDateWindow.getDate() + 6);
      if (new Date(dayDate) > sevenDayDateWindow) {
        this.siteName = this.scheduleUnavailableText;
        this.abbreviatedSiteName = this.scheduleUnavailableText;
      } else {
        this.siteName = this.dayOffText;
        this.abbreviatedSiteName = this.dayOffText;
      }
      this.isDayOff = true;
      this.dayType = dayType === DayTypes.Current ? DayTypes.CurrentAndOff : DayTypes.Off;
    }
  }

  createFixedAppointment(text: string, startTime: string, duration: number) {
    const appt = new Appointment();

    appt.fixed = true;
    appt.fixedText = text;

    appt.startTime = moment(startTime, 'HH:mm:ss');
    appt.endTime = moment(startTime, 'HH:mm:ss').add(duration, 'minutes');

    appt.statusStyle = this.fixedAppointmentStyle;
    appt.appointmentTopPosition = AppointmentsHelper.setAppointmentStartPosition(moment(startTime, 'HH:mm:ss'), this.calendarHeight, this.numberOfHours) / this.browserFontSize;
    appt.appointmentHeight = AppointmentsHelper.setAppointmentHeight(duration, this.calendarPixelPerMinuteCount) / this.browserFontSize;

    this.dailyAppointments.push(appt);
  }
}
